const config = {
    pluginSlug: 'ke-product-catalog',
    availableLang: ['fr_FR'],
    debug: true,
}

const helpers = {
    getLangCode(lang) {
        switch (lang) {
            case 'fr':
                lang = 'fr_FR'
                break
        }

        return lang
    },
}

export function _k(text, lang) {
    try {
        lang = helpers.getLangCode(lang)

        if (!config.availableLang.includes(lang)) {
            return text
        }

        const translations = require(`../../../i18n/languages/${config.pluginSlug}-${lang}.json`)

        if (!translations || Object.keys(translations).length === 0) {
            throw new Error('No translations found.')
        }

        // Vérifie que le mot existe bien dans le JSON et affiche sa traduction si il existe
        if (translations.hasOwnProperty(text)) {
            return translations[text]
        } else {
            throw new Error('The text was not found in the translations.')
        }
    } catch (e) {
        if (config.debug) {
            console.error(e.message, { text })
        }
        return text
    }
}

export function _kn(str_sing, str_plu, num, lang) {
    let text

    try {
        num = parseInt(num)
        lang = helpers.getLangCode(lang)

        text = num <= 1 ? str_sing : str_plu

        if (!config.availableLang.includes(lang)) {
            return text
        }

        const translations = require(`../../../i18n/languages/${config.pluginSlug}-${lang}.json`)

        if (!translations || Object.keys(translations).length === 0) {
            throw new Error('No translations found.')
        }

        // Vérifie que le mot existe bien dans le JSON et affiche sa traduction si il existe
        if (translations.hasOwnProperty(text)) {
            return translations[text]
        } else {
            throw new Error('The text was not found in the translations.')
        }
    } catch (e) {
        if (config.debug) {
            console.error(e.message, { text })
        }
        return text
    }
}
